// Adjust Vehicle TYPE modalSplits based on lever inputs

// import { get, zipWith } from 'lodash';
// import { createSelector } from 'reselect';

import {
  getModalSplitByOwnership,
  getModalSplitByType,
  getModalSplitPublicTransitLever,
  getModalSplitSharedMobilityLever,
  getNumProjectionYears
} from '../index';

import {
  IModalSplit,
  VehicleType
} from './../../types/city';

import {
  MODAL_SPLIT_BY_TYPE_BAU_GROWTH,
} from '../../../data/modelConstants';



/**
 * Adjust Growth Rate for Vehicle Type... cache selectors later.
 */
export const adjustTypeGrowthForSharedMobility = (modalSplit: IModalSplit,
                                      splitGrowth: IModalSplit,
                                      numYears: number,
                                      sharedMobilityLever: number): IModalSplit => {

  const sharedMobilityMultiplier = 1 + (sharedMobilityLever / 10);
  const adjThreeWheelRate = splitGrowth[VehicleType.threeWheel] * sharedMobilityMultiplier;
  const adjThreeWheelSplit = numYears * adjThreeWheelRate + modalSplit[VehicleType.threeWheel];
  const nonThreeWheelTotal = (1 - adjThreeWheelSplit); // This is for growthRate

  const adjCarRate = (splitGrowth[VehicleType.car] * numYears + modalSplit[VehicleType.car]);
  const adjTwoWheelRate = (splitGrowth[VehicleType.twoWheel] * numYears + modalSplit[VehicleType.twoWheel]);
  const adjPublicTransitRate = (splitGrowth[VehicleType.publicTransit] * numYears + modalSplit[VehicleType.publicTransit]);

  // oldTotal
  const oldTotalInverse = 1 / (adjCarRate + adjTwoWheelRate + adjPublicTransitRate);
  // console.log('SM Totals', nonThreeWheelTotal, (adjCarRate + adjTwoWheelRate + adjPublicTransitRate));
  const factor = nonThreeWheelTotal * oldTotalInverse;

  // These are the new splits at the end of the projection
  const adjCarSplit = adjCarRate * factor;
  const adjTwoWheelSplit = adjTwoWheelRate * factor;
  const adjPublicTransitSplit = adjPublicTransitRate * factor;

  // console.log(`SM Split w/ Lever: ${sharedMobilityLever}`, adjCarSplit, adjThreeWheelSplit, adjTwoWheelSplit, adjPublicTransitSplit);

  // Now that we have adjusted splits, let's use them to calculate new growth rates.
  // console.log(modalSplit);
  return {
    [VehicleType.car]: (adjCarSplit - modalSplit[VehicleType.car]) / numYears,
    [VehicleType.twoWheel]: (adjTwoWheelSplit - modalSplit[VehicleType.twoWheel]) / numYears,
    [VehicleType.threeWheel]: (adjThreeWheelSplit - modalSplit[VehicleType.threeWheel]) / numYears,
    [VehicleType.publicTransit]: (adjPublicTransitSplit - modalSplit[VehicleType.publicTransit]) / numYears,
  }
}


/**
 * Adjust Growth Rate for Vehicle Type... cache selectors later.
 * The "base public transit split" is the proportion BEFORE the earlier adjustment.
 * TODO: refactor this and the above function for a generalized "adjust for growth" operation
 * This also means that order of transformations DOES matter...
 * baseSplit means before any adjustments were appplied, whereas modalSplit is values from the previous cell.
 *
 */
export const adjustTypeGrowthForPublicTransit = (modalSplit: IModalSplit,
  splitGrowth: IModalSplit,
  numYears: number,
  publicTransitLever: number,
  baseSplit: IModalSplit): IModalSplit => {
  // console.log('Begin PT Calculation');

  const publicTransitBonus = (publicTransitLever * .01);
  const adjPublicTransitRate = MODAL_SPLIT_BY_TYPE_BAU_GROWTH[VehicleType.publicTransit] + publicTransitBonus;

  const adjPublicTransitSplit = numYears * adjPublicTransitRate + baseSplit[VehicleType.publicTransit];
  const nonPublicTransitTotal = (1 - adjPublicTransitSplit); // This is for growthRate

  // This is column O / P of the spreadsheet, the "Adjusted Percentages"
  // get new end-state modal splits when the publicTransit gets redistributed
  const adjCarRate =  modalSplit[VehicleType.car];
  const adjTwoWheelRate = modalSplit[VehicleType.twoWheel];
  const adjThreeWheelRate = modalSplit[VehicleType.threeWheel];

  // console.log(modalSplit[VehicleType.car]);

  // oldTotal
  const oldTotal = modalSplit[VehicleType.car] + modalSplit[VehicleType.twoWheel] + modalSplit[VehicleType.threeWheel];
  const oldTotalInverse = 1 / oldTotal;
  // console.log('PT Totals', nonPublicTransitTotal, oldTotal);
  const factor = nonPublicTransitTotal * oldTotalInverse;

  // These are the new splits at the end of the projection
  const adjCarSplit = adjCarRate * factor;
  const adjTwoWheelSplit = adjTwoWheelRate * factor;
  const adjThreeWheelSplit = adjThreeWheelRate * factor;

  // Q9:Q12
  // console.log(`Public Transit Split w/ Lever: ${publicTransitLever}`, adjCarSplit, adjThreeWheelSplit, adjTwoWheelSplit, adjPublicTransitSplit);

  // Now that we have adjusted splits, let's use them to calculate new growth rates using the source
  const numYearsInverse = 1/ numYears;
  const results = {
    [VehicleType.car]: (adjCarSplit - baseSplit[VehicleType.car]) * numYearsInverse,
    [VehicleType.twoWheel]: (adjTwoWheelSplit - baseSplit[VehicleType.twoWheel]) * numYearsInverse,
    [VehicleType.threeWheel]: (adjThreeWheelSplit - baseSplit[VehicleType.threeWheel]) * numYearsInverse,
    [VehicleType.publicTransit]: (adjPublicTransitSplit - baseSplit[VehicleType.publicTransit]) * numYearsInverse,
  }
  return results;
}



// WEBPACK FOOTER //
// ./src/store/selectors/modalSplit/leverAdjustByType.ts